import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";

import time from "../../images/timeproven.png";

// const Heading = StyledEngineProvider
const Wrapper = styled.div`
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-image: url(${time});
  color: #ffffff;
  @media (max-width: 599px) {
    min-height: 80vh;
  }
  `;
const Heading = styled.div`
  font-size: 70px;
  font-weight: 900;
  line-height: 80px;
  @media (max-width: 1199px) {
    line-height: 50px;
    padding-top: 180px;
    font-size: 50px;
  }
  @media (max-width: 599px) {
    line-height: 40px;
    padding-top: 130px;
    font-size: 40px;
  } ;
`;
const Text = styled.div`
  padding-top: 15px;
  line-height: 20px;
  max-width: 85%;
  @media (max-width: 599px) {
    max-width: 100%;
  } ;
`;
const Cells = styled.div`
  padding-top: 200px;
  padding-left: 100px;
  @media (max-width: 1199px) {
    padding-top: 0px;
    padding-left: 100px;
  }
  @media (max-width: 899px) {
    padding-top: 0px;
    padding-left: 210px;
  } 
  @media (max-width: 599px) {
    padding-top: 0px;
    padding-left: 0px;
  } ;
`;
const index = () => {
  return (
    <div>
      <Wrapper>
        <Container>
          <Grid container alignItems="center">
            <Grid item xs={12} md={6}></Grid>
            <Grid item xs={12} md={6}>
              <Cells>
                <Heading>Time Proven Quality And Sustanibility</Heading>
                <Text>
                  Earthquake resistant. Long lasting. All weather proof
                  conditions. Free from traditional construction problems like
                  seepage, leaks. Protected from the impact/effects of fire and
                  water. Flexible cost saving facilities. With the scope to
                  enhance the inner and outer beauty.
                </Text>
              </Cells>
            </Grid>
          </Grid>
        </Container>
      </Wrapper>
    </div>
  );
};

export default index;
